import { render, staticRenderFns } from "./LayoutBox.vue?vue&type=template&id=4b11c893&scoped=true"
import script from "./LayoutBox.vue?vue&type=script&lang=js"
export * from "./LayoutBox.vue?vue&type=script&lang=js"
import style0 from "./LayoutBox.vue?vue&type=style&index=0&id=4b11c893&prod&lang=scss&scoped=true"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "4b11c893",
  null
  
)

export default component.exports